const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  add ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-record/add', params)
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-record/delete', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
